// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"modalWrapper__3mNO-","modalContainer":"modalContainer__1q1gR","controls":"controls__1QR-J","iconClose":"iconClose__3iY3p"};


//////////////////
// WEBPACK FOOTER
// ./components/spareparts/modal/style.less
// module id = ipN0
// module chunks = 75